module.exports = __webpack_public_path__ + "media/Audio15_o.37cb6f6f.wav";